export function formatRegionalTime(
  value: Date | number,
  locale: string | null,
  timeZone: string | null,
): string {
  return new Intl.DateTimeFormat(locale ?? undefined, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    ...(timeZone ? { timeZone } : {}),
  }).format(value);
}
